module.exports = __webpack_public_path__ + "img/bg-popup-3.d379ba7a.jpeg";